import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function falhasReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    async function getChart(conformidade, status) {
        let barColor;

        switch (status) {
            case "Ótimo":
                barColor = "#6bd72d";
                break;
            case "Bom":
                barColor = "#6bd72d";
                break;
            case "Regular":
                barColor = "#ecdb23";
                break;
            case "Ruim":
                barColor = "#fe4719";
                break;
            default:
                barColor = "#fe4719";
        }

        return h.barChart(
            {
                columns: ["", "", "Média (%)", "", ""],
                domain: [0, 4],
                // ticks: [0, 1, 2, 3, 4],
                width: 500,
                height: 300,
                meta: params.meta,
                series: [{ name: "", values: [0, 0, conformidade, 0, 0], props: { type: "monotone", fill: barColor } }],
            },
            { alignment: "center", colSpan: 3, width: 180 }
        );
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart);
}
